import { render, staticRenderFns } from "./EditDocks.vue?vue&type=template&id=11ab2563&"
import script from "./EditDocks.vue?vue&type=script&lang=js&"
export * from "./EditDocks.vue?vue&type=script&lang=js&"
import style0 from "./EditDocks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports